import { render } from "./HippoImage.vue?vue&type=template&id=f5493b18"
import script from "./HippoImage.vue?vue&type=script&lang=js"
export * from "./HippoImage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lougotz/Sites/hippocrates/glossary-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__